"use client"

import { Routes } from "@/lib/routes"
import { useRouter } from "next/navigation"
import { VscSearchSparkle } from "react-icons/vsc"
import { motion } from "motion/react"

type SearchButtonProps = {
   toggleNavMenu: () => void
   className?: string
   placeholder?: string
   showText?: boolean
}

function SearchButton({
   toggleNavMenu,
   className,
   placeholder = "Ask restaurant AI...",
   showText = true,
}: SearchButtonProps) {
   const router = useRouter()

   const handleClick = () => {
      router.push(
         Routes.client.search.getPath({
            articles: true,
            videos: true,
            library: true,
            templates: true,
            query: "",
         }),
      )

      toggleNavMenu()
   }

   const shouldAnimate = () => {
      return typeof window !== "undefined" && window.matchMedia("(min-width: 1024px)").matches
   }

   return (
      <motion.div
         onClick={handleClick}
         role="button"
         tabIndex={0}
         onKeyDown={(e) => {
            if (e.key === "Enter" || e.key === " ") handleClick()
         }}
         className={[
            "group inline-flex w-full  cursor-pointer items-center rounded-xl bg-[length:300%_auto] p-[2px] ",
            showText && " bg-gradient-to-r from-[#2D7CFF] via-[#7B61FF] to-[#FF6A3D]",
            className ?? "",
         ].join(" ")}
         animate={
            shouldAnimate()
               ? {
                    backgroundPosition: ["0% center", "200% center"],
                    scale: [1, 1.015, 1],
                    transition: {
                       backgroundPosition: {
                          duration: 3,
                          repeat: Infinity,
                          repeatType: "loop",
                          ease: "linear",
                       },
                       scale: {
                          duration: 2,
                          repeat: Infinity,
                          repeatType: "reverse",
                          ease: "easeInOut",
                       },
                    },
                 }
               : {}
         }
      >
         <div
            className={[
               "flex h-full w-full cursor-pointer items-center rounded-[10px] bg-[#F4F4F4]",
               showText ? "gap-3 px-[12px] py-[10px]" : "justify-center px-0",
            ].join(" ")}
         >
            <VscSearchSparkle className="h-5 w-5 shrink-0 text-[#6B5CF6]" aria-hidden="true" />
            {showText ? (
               <span className="truncate text-[15px] font-normal text-[#6B7280]">{placeholder}</span>
            ) : (
               <span className="sr-only">{placeholder}</span>
            )}
         </div>
      </motion.div>
   )
}

export default SearchButton
